// extracted by mini-css-extract-plugin
module.exports = {"cropper":"QjXp-LftY3"};